/*
  © 2024–2026 Atlas PHM
  Independently developed software. All rights reserved.
*/

/**
 * ⚠️ DEPRECATED: Legacy Interactive Story UI — DO NOT EDIT ⚠️
 * 
 * This screen is part of the deprecated interactive story journey.
 * It is NOT routed in production and kept only for backwards compatibility.
 * 
 * The LIVE production UI is the Hub System Assessment at /hub
 * 
 * DO NOT make changes to this file unless fixing security vulnerabilities.
 * All new features should be added to the Hub UI instead.
 */

/**
 * Screen 2: What Stays the Same
 * Explains that total heat delivered stays the same
 */

import DeepDive from '../../components/DeepDive';
import { deepDives } from '../../content/deepDiveContent';
import { useRecommendation } from '../../context/RecommendationContext';
import { gbp } from '../../utils/formatters';
import { buildSummaryLine, formatReportValue } from './reportUtils';

function Screen2WhatStaysSame() {
  const { collectedData, recommendationResult } = useRecommendation();
  const baseline = recommendationResult?.output?.baselineResult;

  const currentSystemDetails = [
    {
      label: 'Current system',
      value: buildSummaryLine(collectedData?.boilerType, collectedData?.waterSystem),
    },
    {
      label: 'Fuel type',
      value: formatReportValue(collectedData?.currentFuelType),
    },
    {
      label: 'System age',
      value: formatReportValue(collectedData?.systemAge),
    },
    {
      label: 'Efficiency info',
      value: buildSummaryLine(collectedData?.sedbukBand, collectedData?.epcBand),
    },
  ];

  return (
    <div className="interactive-story-screen">
      <h1 className="screen-title">What Stays the Same</h1>

      <div className="screen-body">
        <p className="screen-text emphasis">
          The total heat delivered to your home stays the same.
        </p>

        <div className="screen-text secondary">
          Comfort comes from how smoothly heat is delivered over time, not from delivering more heat.
          <DeepDive
            trigger="Why?"
            content={deepDives.comfortVsHeat}
          />
        </div>

        <div className="report-section">
          <h2 className="report-section-title">Your current system snapshot</h2>
          <div className="report-section-grid">
            {currentSystemDetails.map((detail) => (
              <div key={detail.label} className="report-section-card">
                <p className="report-section-label">{detail.label}</p>
                <p className="report-section-value">{detail.value}</p>
              </div>
            ))}
          </div>
        </div>

        {baseline && (
          <div className="report-section">
            <h2 className="report-section-title">Baseline cost outlook</h2>
            <div className="report-section-grid">
              <div className="report-section-card">
                <p className="report-section-label">Annual running cost</p>
                <p className="report-section-value">{gbp(baseline.annualizedCost_gbp)}</p>
              </div>
              <div className="report-section-card">
                <p className="report-section-label">Total cost over {baseline.periodYears ?? 20} years</p>
                <p className="report-section-value">{gbp(baseline.totalCost_gbp)}</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Screen2WhatStaysSame;
